<div class="toast-msg-conatiner" *ngIf="showToast">
    <div class="toast-msg" [style.backgroundColor]="isSuccess ? '#73d76a' : '#f54b4b'">
        {{notificationMsg}}
    </div>
</div>

<div class="row no-gutters w-100">
    <div *ngFor="let item of subscriptionPlans" class="col-12 p-2 row no-gutters">
        <div class="col-12 grid-container grid-hover p-3 row no-gutters" style="background-image: url('assets/images/bg01.png');">
            <div class="col-12 row no-gutters">
                <div class="col-12">
                    <span style="font-size: 25px; font-weight: 700;">{{item.Name}}</span>
                </div>

                <div class="col-12 d-flex flex-column">
                    <div style="font-weight: 600; font-size: 20px;">
                        {{item.Amount ? (item.Amount | currency : 'INR' : 'symbol' : '1.0-0') : "Free"}}
                    </div>
                    <div class="font-weight-light" style="font-size: 12px; color: #525b75;">
                        {{item.Period}} days
                    </div>
                </div>

                <div class="col-12 row no-gutters">
                    <div class="col-12 d-flex flex-column">
                        <div *ngFor="let point of item.planDetails" class="d-flex align-items-center mt-2 list-item">
                            <i class="material-icons-outlined pr-2">check_circle_outline</i>
                            <span>{{point}}</span>
                        </div>
                    </div>
                </div>

                <div class="col-12 mt-3">
                    <button (click)="onClickPlan(item)" [ngClass]="{'btn-primary': item.ID === selectedPlan.SubscriptionID, 'btn-outline-primary': item.ID !== selectedPlan.SubscriptionID}" 
                    class="btn w-100 p-2" data-toggle="modal" data-target="#selectedPlan">
                    {{item.ID === selectedPlan.SubscriptionID ? 'Subscribed' : 'Subscribe'}}
                    </button>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="loading" class="d-flex justify-content-center w-100">
        <div class="spinner-border m-auto" role="status">
            <span class="sr-only "></span>
        </div>
    </div>
</div>

<div class="modal fade" id="selectedPlan" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Selected Plan</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="row no-gutters p-3">
                <div class="col-12 row no-gutters">
                    <div class="col-12 row no-gutters">
                        <div class="col-12">
                            <span style="font-size: 25px; font-weight: 700;">{{selectedPlan?.Name}}</span>
                        </div>
        
                        <div class="col-12 mb-2 d-flex flex-column">
                            <div style="font-weight: 600; font-size: 20px;">
                                {{selectedPlan?.Amount ? (selectedPlan?.Amount | currency : 'INR' : 'symbol' : '1.0-0') : "Free"}}
                            </div>
                            <div class="p-text-light" style="font-size: 12px; color: #525b75;">
                                {{selectedPlan?.Period}} days
                            </div>
                        </div>
        
                        <div class="col-12 row no-gutters">
                            <div class="col-12 d-flex flex-column">
                                <div *ngFor="let point of selectedPlan?.planDetails" class="d-flex align-items-center mt-2 list-item">
                                    <i class="material-icons-outlined pr-2">check_circle_outline</i>
                                    <span>{{point}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
        
                <div class="col-12 mt-4 d-flex align-items-center" style="border: 1px solid #3f3f3f53; border-radius: 5px;">
                    <div class="p-2">
                        <div class="font-weight-bold" style="color: #555;">{{contactNumber}}</div>
                        <div class="font-italic" style="color: #323844;">*Contact us to activate selected plan</div>
                    </div>
                    <div class="d-flex ml-auto p-2">
                        <i (click)="copyToClipBoard()" class="material-icons-outlined" style="font-size: 30px; color: #555;">content_copy</i>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>